import { ChangesMap } from '../enums/changes-map.enum';

export class MarkerClusterOptions {

    public apiUrl: string;
    public minClusterSize?: number;
    public changesMap?: ChangesMap;
    public filter?: any;

    constructor(obj: Partial<MarkerClusterOptions>) {
        Object.assign(this, obj);
    }

}
